import { useState } from 'react';
import styles from './linkDownloadButton.module.css';

const LinkDownloadButton = (props) => {

    const [isHovering, setIsHovering] = useState(false);

    const hoveringOn = () => {
        setIsHovering(true);
        
    }

    const hoveringOff= () => {
        setIsHovering(false);
    }

    const animationBarActive1 = isHovering ? styles.animationBarActivated1 : styles.animationBar1;
    const animationBarActive2 = isHovering ? styles.animationBarActivated2 : styles.animationBar2;
    const animationBarActive3 = isHovering ? styles.animationBarActivated3 : styles.animationBar3;
    const animationBarActive4 = isHovering ? styles.animationBarActivated4 : styles.animationBar4;
    const linkText = isHovering ? styles.linkTextHover : styles.linkText


    return(

        <div className={styles.buttonBox}>
            <span className={animationBarActive1}></span>
            <span className={animationBarActive2}></span>
            <span className={animationBarActive3}></span>
            <span className={animationBarActive4}></span>

            <div className={styles.linkButton} onMouseEnter={hoveringOn} onMouseLeave={hoveringOff}>
                <a aria-label="Pressetext im PDF-Format herunterladen" href={props.destination} className={linkText} download>{props.children}</a></div>
        </div>

    
    );
}

export default LinkDownloadButton;